const MONTH_LABEL_MIN_WIDTH_PX = 30;

export const thinMonthMarkers = <T extends { leftPct: number }>(
  markers: T[],
  minimapWidth: number,
): T[] => {
  if (markers.length <= 1 || minimapWidth <= 0) return markers;

  const pixelsPerMonth = minimapWidth / markers.length;
  const stride = Math.max(1, Math.ceil(MONTH_LABEL_MIN_WIDTH_PX / pixelsPerMonth));

  const visible = markers.filter((_, index) => index % stride === 0);

  const [first, second] = visible;
  if (
    first !== undefined &&
    second !== undefined &&
    ((second.leftPct - first.leftPct) / 100) * minimapWidth < MONTH_LABEL_MIN_WIDTH_PX
  ) {
    visible.shift();
  }

  return visible;
};
